import { atom } from 'recoil';

const pickMealAt = atom<Date | null>({
  key: 'pickMealAt',
  default: null,
});

export default pickMealAt;
